const phoneNumberValidator = phoneNumber =>
  phoneNumber.trim().match(/^\+?[\d-() ]+$/);

export default phoneNumberValidator;
